import type { NextPageContext } from 'next';
import type { ShareType } from './shareTypes';
import { toMetaTags } from './utils/metaTags';
import { toShareProps } from './utils/shareProps';

export const toHandler = async (context: NextPageContext, shareType: ShareType) => {
  try {
    const { req, query, asPath } = context;
    const shareProps = toShareProps(shareType, query);
    const metaTags = await toMetaTags(shareType, shareProps, req, query, asPath);
    return metaTags;
  } catch (error) {
    console.error(error);
    return [];
  }
};
